/**
 * Handle bill consumption kind
 */
export enum ConsumptionKind {
  ELECTRICITY = 1,
  GAS = 2,
  HEAT = 3,
}
